import { SampleDetailsPageSection } from './SampleDetailsPageSection';
import { useGetSampleDetailsQuery } from '@viome/viome-base/src/usecase/Misc/MiscQuery';

export interface SampleDetailsPageLabInformationSectionProps
  extends React.ComponentProps<'div'> {
  isLoading?: boolean;
  sampleId?: string;
  'data-testid'?: string;
}

export const SampleDetailsPageLabInformationSection = ({
  isLoading,
  sampleId,
  'data-testid': testId,
  ...rest
}: SampleDetailsPageLabInformationSectionProps) => {
  const { data: samples } = useGetSampleDetailsQuery();
  const currentSample = samples?.find(
    sample => sample.sample_information.sample_id === sampleId
  );
  const labInfo = currentSample?.lab_information;

  const allLabData = [
    {
      label: 'Lab Name',
      value: labInfo?.lab_name,
    },
    {
      label: 'Lab Address',
      value: labInfo?.address ? 
        `${labInfo.address.address_line1}, ${labInfo.address.address_line2}`.trim() : 
        undefined,
    },
    {
      label: 'Lab Contact',
      value: labInfo?.contact,
    },
    {
      label: 'CLIA License Number',
      value: labInfo?.clia_license_number,
    },
  ];

  const labData = allLabData.filter(
    item => item.value !== null && 
           item.value !== undefined && 
           item.value !== '' &&
           item.value !== ', '  
  );

  return (
    <SampleDetailsPageSection
      {...rest}
      title="Lab Information"
      data={labData}
      isLoading={isLoading}
      data-testid={testId}
    />
  );
};